<template>
    <main-panel class="news__item">
        <template v-slot:header>
            <h2>{{ news.header }}</h2>
            <h4>{{news.data_news_t}}</h4>
        </template>
        <section style="margin-bottom: 64px;">
            <h6 id="photo"></h6>
            <panel-ms  class="news__foto">
                <img :src="news.src" :alt="news.header">
            </panel-ms>
            <h6 id="description"></h6>
            <div class="html__panel">
                <panel-ms >
                    <div v-html="news.body"></div>
                </panel-ms>
            </div>
        </section>
    </main-panel>
</template>
<script>
import axios from 'axios';
import mainPanel from '../main/mainPanel.vue';
import panelMs from '../common/panelMs.vue';
export default{
    components:{
        mainPanel,
        panelMs
    },
    mounted(){
        axios
            .get('https://mosp51.ru/api/news?id='+this.$route.params.path)
            .then(response=>{
                this.news = response.data
                this.$route.matched[this.$route.matched.length-1].name = response.data.header
            })
    },
    data(){
        return{
            news:{}
        }
    }
}
</script>
<style>
.news__item .main__panel__header h2{
    margin-bottom: 16px;
}
.news__item .main__panel__header h4{
    font-size: 16px;
    color: #919191;
    font-weight: 400;
    margin: 0;
    margin-bottom: 64px;
}
.news__item .news__foto img{
    height: 600px;
    width: 600px;
    object-fit: left;
}
.news__item .news__foto {
    margin-bottom: 32px;
}
.news__item  h6{
    scroll-margin-top: 240px;
    margin: 0;
}
@media (max-width: 1000px){   
    .news__item .main__panel__header h4{
        font-size: 14px;
        margin-bottom: 48px;
    }
    .news__item .news__foto{
        margin-bottom: 24px;
    }
    .news__item .news__foto img{
        width: 100%;
        height: auto;
    }
}
</style>